import React from 'react';
import PropTypes from 'prop-types';

const HeaderProfileContent = ({
  children = null,
  iconClassName = null,
  iconText = null,
}) => (
  <div className="vf-header-profile__content">
    <div className="vf-header-profile__content__icon">
      <i className={iconClassName}>{iconText}</i>
    </div>
    <div className="vf-header-profile__content__text">
      {children}
    </div>
  </div>
);

HeaderProfileContent.displayName = 'Header Profile Content';

HeaderProfileContent.propTypes = {
  children: PropTypes.string,
  iconClassName: PropTypes.string,
  iconText: PropTypes.string,
};

export default HeaderProfileContent;
